<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/contoursofdarkness_ch01#ch01">1<br/> Trapeze</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><a href="#/contoursofdarkness_ch02#ch02">2<br/> In The Middle Of A Middle</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch03#ch03" title="Link target outside of Sample">3<br/> Little Signs In Lava Flow</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch04#ch04" title="Link target outside of Sample">4<br/> Blind Vision</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch05#ch05" title="Link target outside of Sample">5<br/> The Driven</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch06#ch06" title="Link target outside of Sample">6<br/> Comrade Cunt</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch07#ch07" title="Link target outside of Sample">7<br/> Sweet Satori Blues</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch08#ch08" title="Link target outside of Sample">8<br/> The Frigid Orgasm</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch09#ch09" title="Link target outside of Sample">9<br/> Klein Worms</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber"><span href="#/contoursofdarkness_ch10#ch10" title="Link target outside of Sample">10<br/> Dejà Vu</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contoursofdarkness_con01.vue?f1738efe